import { QUERY_SEPARATOR, QUERY_PARAM_SEPARATOR, QUERY_DEFAULT_ALLOWLIST, } from '../consts/consts';
var splitOnFirst = function (string, separator) {
    var index = string.indexOf(separator);
    return index === -1
        ? [string]
        : [string.slice(0, index), string.slice(index + separator.length)];
};
export var isAllowedLangValue = function (pair, allowedLangValues) {
    if (allowedLangValues !== undefined) {
        var _a = splitOnFirst(pair, '='), key = _a[0], value_1 = _a[1];
        if (key === 'lang') {
            return allowedLangValues.some(function (lang) { return lang === value_1; });
        }
    }
    return true;
};
/**
 * Sanitizes the given URL by leaving only supported query params.
 *
 * @param {String} url to sanitize
 */
export function sanitizeUrl(url, allowList, allowedLangValues) {
    if (allowList === void 0) { allowList = QUERY_DEFAULT_ALLOWLIST; }
    if (allowedLangValues === void 0) { allowedLangValues = undefined; }
    if (typeof url === 'string') {
        var queryIndex = url.indexOf(QUERY_SEPARATOR);
        if (queryIndex !== -1) {
            var _a = url.split(QUERY_SEPARATOR), urlWithoutQuery = _a[0], query = _a[1];
            var sanitizedQuery = query
                .split(QUERY_PARAM_SEPARATOR)
                .filter(function (pair) { return allowList.some(function (key) { return pair.startsWith(key); }); })
                .filter(function (pair) { return isAllowedLangValue(pair, allowedLangValues); })
                .join(QUERY_PARAM_SEPARATOR);
            if (sanitizedQuery) {
                return "".concat(urlWithoutQuery).concat(QUERY_SEPARATOR).concat(sanitizedQuery);
            }
            return urlWithoutQuery;
        }
        return url;
    }
    return undefined;
}
